import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import InventoryForm from './forms/InventoryForm';
import InventoryList from './lists/InventoryList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

const types = {
    "1": {value: "1", label: "Teljes"},
    "2": {value: "2", label: "Részleges"},
    "3": {value: "3", label: "Külső"},
}

class InventoryEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.setPristineValues({type: "3", state: 0});
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || (this.props.values.state || 0) + "" !== "0"
        return props;
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header="Leltár lista"
            >
                <InventoryList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} types={types} />
            </List>
            <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Leltár adatai"
            >
                <InventoryForm {...this.props} getFieldProps={this.getFieldProps} types={types} />
            </Editor>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "Inventory",
    editor: "Inventories",
    WrappedComponent: InventoryEditor,
    props: {
        view: "admin"
    }
});
